

export default (() => {
    return {
        //Medmal
        getCity:"/tpClaim/city",
        getRegion:"/tpClaim/getRegions",
        getProfession:"/common/getOccupationDescription",

        //Medmal Claim
        getCustomerDetails:"/login/customerLogin",
        customerPolicyDetails:"/medmalclaim/policyList",
        customerExistingClaims:"/medmalclaim/getClaimDetails",
        claimsLossTypes:"/medmalclaim/lossTypes",
        validateClaim:"/medmalclaim/validate",
        submitClaim:"/medmalclaim/submit",
        submitBailBondClaim:"/medmalclaim/bailbond",
        submitCourtBondClaim:"/medmalclaim/courtverdict",
    }
})();
